var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "popup",
      staticClass: "added_to_cart_popup",
      class: [{ shown: _vm.show }],
      attrs: { id: "added_to_cart" },
    },
    [
      _c(
        "div",
        { staticClass: "atc_body" },
        [
          _vm.withCloseButtons
            ? _c(
                "button",
                {
                  staticClass: "atc_close js_close",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closePopup.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "sr--only" }, [
                    _vm._v(_vm._s(_vm.options.labels.close)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticClass: "svg-icon",
                      attrs: { viewBox: "0 0 20 20" },
                    },
                    [
                      _c("path", {
                        attrs: {
                          stroke: "#333",
                          "stroke-width": "2",
                          d: "M 5 5 L 15 15 M 5 15 L 15 5",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.withDotsLoader
            ? _c(
                "div",
                {
                  staticClass:
                    "awaiting_overlay displayed partial dots_loader mt_40",
                },
                [_c("p", { attrs: { loader: "loading" } })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.withCloseButtons
            ? _c(
                "button",
                {
                  staticClass: "atc_button white keep",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.closePopup.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.options.labels.ok) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }